<template>
	<div class="header-messages">
		<button
			v-if="hasChatsAccess"
			type="button"
			class="header-messages__btn"
			title="Сообщения"
			@click="onClick"
		>
			<app-icon
				name="envelope"
				width="20px"
				height="20px"
				cursor="pointer"
				class="header-messages__icon"
			/>
			<span class="header-messages__counter">{{ count }}</span>
		</button>

		<header-messages-modal ref="$modal" />
	</div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue"
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import HeaderMessagesModal from "./HeaderMessagesModal.vue"
import { headerStore } from "@/store/header"
import { rootStore } from "@/store/index"

const store = headerStore()
const root = rootStore()
const $modal = ref<InstanceType<typeof HeaderMessagesModal> | null>(null)

const count = computed(() => store.unreadMessagesCount)
const hasChatsAccess = computed(() => store.chatsAccess !== false)

const onClick = () => {
	$modal.value?.open()
}

const fetchOnce = () => {
	if (!store.getDialogs?.length) {
		store.fetchDialogs()
	}
}

onMounted(() => {
	if (root.globalJWT) {
		fetchOnce()
		return
	}
	const unwatch = watch(() => root.globalJWT, (token) => {
		if (token) {
			fetchOnce()
			unwatch()
		}
	})
})
</script>

<style scoped>
.header-messages {
	position: relative;
}

.header-messages__btn {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	background: transparent;
	border: none;
	color: #fff;
	cursor: pointer;
	padding: 4px 0;
	font-family: inherit;
	transition: color 0.15s ease;
}

.header-messages__btn:hover {
	color: #F9C22F;
}

.header-messages__counter {
	color: inherit;
	font-size: 20px;
	font-weight: 600;
	line-height: 1;
}
</style>
